import { STORAGE_KEYS } from '@/constants'

class LocalstorageService {
  constructor(storage = window.localStorage) {
    this.storage = storage
  }

  setItem(key, value, serialize = false) {
    try {
      const serializedValue = serialize ? JSON.stringify(value) : value
      this.storage.setItem(key, serializedValue)
      return true
    } catch (error) {
      console.error('Error saving to localStorage:', error)
      return false
    }
  }
  getItem(key, defaultValue = null, deserialize = false) {
    try {
      const item = this.storage.getItem(key)
      return item ? (deserialize ? JSON.parse(item) : item) : defaultValue
    } catch (error) {
      console.error('Error reading from localStorage:', error)
      return defaultValue
    }
  }
  removeItem(key) {
    try {
      this.storage.removeItem(key)
      return true
    } catch (error) {
      console.error('Error removing item from localStorage:', error)
      return false
    }
  }
  clear() {
    try {
      this.storage.clear()
      return true
    } catch (error) {
      console.error('Error clearing localStorage:', error)
      return false
    }
  }
  hasItem(key) {
    return this.storage.hasOwnProperty(key)
  }
  getKeys() {
    return Object.keys(this.storage)
  }
  getSize() {
    return this.storage.length
  }
}

const localStorageService = new LocalstorageService()
export const sessionStorageService = new LocalstorageService(
  window.sessionStorage
)
export default localStorageService
